import { useEffect } from 'react';
import { useMatches } from 'react-router-dom';
import { useTranslation } from '@root/app/shared/hooks/useTranslation';

interface RouteHandle {
    pageTitle?: string;
}

export const usePageTitle = (): void => {
    const matches = useMatches();
    const { t } = useTranslation();

    useEffect(() => {
        const match = matches[matches.length - 1];
        const handle = match?.handle as RouteHandle | undefined;
        const title = handle?.pageTitle
            ? `Happyforce | ${t(handle.pageTitle)}`
            : 'Happyforce';
        document.title = title;
    }, [matches, t]);
};
